import { useTranslation } from 'react-i18next';

import { Body1 } from '@myphx-engineering/phx-design-system';
import { GrayPillsIllustration, IllustrationCard } from '@phx/myphx-lib';

export const HomeMedCabNoOrders = () => {
    const { t } = useTranslation();

    return (
        <IllustrationCard
            Illustration={GrayPillsIllustration}
            variant="bare"
            color="gray"
            // oxlint-disable-next-line jsx-a11y/role-has-required-aria-props -- tracked in docs/oxlint-violations.md
            role="tab"
            illustrationPosition="right"
            withShadow={false}
        >
            <Body1>{t('cabinet.noOrdersCard.body')}</Body1>
        </IllustrationCard>
    );
};
